module.exports = ".settings i {\r\n    font-size: 30px;\r\n    color: #545454;\r\n}\r\n\r\n.settings a {\r\n    text-align: center;\r\n}\r\n\r\n    .settings a,\r\n    .settings a:visited,\r\n    .settings a:hover,\r\n    .settings a:active {\r\n        text-decoration: none;\r\n        color: #545454;\r\n    }\r\n\r\n.child-divs-have-margins > div {\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n}\r\n\r\n.gray2 {\r\n    background-color: #eaeaea;\r\n}\r\n\r\n.with-mat-form-field-bottom-padding {\r\n    padding-bottom: 1.25em;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/activities/overview/overview-options.component.css
// module id = 1280
// module chunks = 1